import React, { useState, useEffect } from 'react';
import QuestionContent from './QuestionContent';
import QuestionSidebar from './QuestionSidebar';
import { Error404 } from '@/components/custom/error';
import useAuthorityLevel from '@/hooks/useAuthorityLevel';
import { t } from 'i18next';
import { Dashboard, DashboardContent } from '@/layouts/dashboard';

export default function CreateQuestion(props) {
  const { step } = props;
  const authorityLevel = useAuthorityLevel();

  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      id: 0,
      route: 'nome',
      text: t('exams.stepsTextName')
    },
    {
      id: 1,
      route: 'informacoes',
      text: t('exams.stepsTextInfo')
    },
    {
      id: 2,
      route: 'tipo',
      text: t('exams.stepsTextType')
    },
    {
      id: 3,
      route: 'visibilidade',
      text: t('exams.stepsTextVisibility')
    }
  ];

  function getStep() {
    switch (step) {
      case 'nome':
        setCurrentStep(0);
        break;
      case 'informacoes':
        setCurrentStep(1);
        break;
      case 'tipo':
        setCurrentStep(2);
        break;
      case 'visibilidade':
        setCurrentStep(3);
        break;
      default:
        setCurrentStep(0);
        break;
    }
  }

  useEffect(() => getStep());

  return authorityLevel !== 'student' ? (
    <Dashboard>
      <QuestionSidebar
        currentStep={currentStep}
        steps={steps}
      />

      <DashboardContent viewMode="create">
        <QuestionContent
          step={step}
          steps={steps}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
        />
      </DashboardContent>
    </Dashboard>
  ) : (
    <Error404 />
  );
}
